import { Fragment, useMemo } from 'react';
import jwtDecode from 'jwt-decode';
import { Menu, Transition } from '@headlessui/react';
import { useAuth } from '~src/hooks/useAuth';
import UserCircleIcon from '@heroicons/react/24/outline/UserCircleIcon';
import Link from '../Link';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function AvatarMenu({ disabled = false }) {
  const { user, signout } = useAuth();

  function handleSignout(e) {
    e.preventDefault();

    signout();

    return false;
  }

  const username = useMemo(() => {
    if (user) {
      const token = user.accessToken;
      if (token) {
        const userTokenData = jwtDecode(token);
        return userTokenData.memberName;
      }
    }
  }, [user]);

  if (!user) {
    return null;
  }

  const userNavigation = [
    { name: 'Dashboard', href: '/dashboard' },
    { name: 'Settings', href: '/settings' },
  ];

  //console.log(user)

  return (
    <div className="avatar-menu" key="avatar-menu">
      <Menu as="div" className="relative">
        <div>
          <Menu.Button className="flex w-7 md:w-10 items-center rounded-full bg-white text-sm text-giveGray-500 hover:text-giveGray-400 focus:outline-none focus:ring-2 focus:ring-brand-200 focus:ring-offset-2">
            <span className="sr-only">Open user menu</span>
            {user.photoURL === null ? (
              <UserCircleIcon className="h-10 w-10" />
            ) : (
              <img
                className={'w-7 md:w-10 rounded-full border-2 border-solid border-giveGray-500 hover:opacity-60 flex justify-center items-center'}
                src={user.photoURL}
                alt="Profile picture"
              />
            )}
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 z-10 mt-4 w-56 origin-top-right rounded-md bg-white py-1 shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none text-sm">
            <Menu.Item>
              <div className="py-2 px-4 border-b border-giveGray-200 border-solid">
                {/*<div className="text-xs text-giveGray-400">Status: {status}</div>*/}
                <div className="font-bold">{username}</div>
                <div className="truncate">{user.email}</div>
              </div>
            </Menu.Item>
            {userNavigation.map((item) => (
              <Menu.Item key={item.name}>
                {({ active }) => (
                  <Link
                    disabled={disabled}
                    href={item.href}
                    className={classNames(
                      active ? 'bg-giveGray-100' : '',
                      'block px-4 py-2 text-giveGray-700'
                    )}
                  >
                    {item.name}
                  </Link>
                )}
              </Menu.Item>
            ))}

            <Menu.Item>
              {({ active }) => (
                <a
                  href="/signout"
                  className={classNames(
                    active ? 'bg-brand-200 text-white' : 'text-giveGray-700',
                    'block px-4 py-2'
                  )}
                  onClick={handleSignout}
                >
                  Sign out
                </a>
              )}
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}
